import highlightDisplayText from '../utils/highlightDisplayText';
import { SegmentScenario } from '../store/schema/SegmentScenario';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from 'office-ui-fabric-react/lib';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { SubstrateSearchSuggestionPersonSegment } from 'owa-search-service';
import React from 'react';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');
const suggestionStyles = require('./suggestionsCallout/SearchSuggestion.scss');
const classNames = require('classnames');

export interface PeopleSuggestionSegmentProps extends PersonaCardBehaviorProps {
    segment: SubstrateSearchSuggestionPersonSegment;
    scenario: SegmentScenario;
}

export default observer(function PeopleSuggestionSegment(props: PeopleSuggestionSegmentProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    const { emailAddress, name, segment, scenario, mailBoxType } = props;
    const highlightTextRegions = highlightDisplayText(segment.DisplayText);

    const peopleSuggestionSegmentNameClassNames = classNames(
        searchBoxPillWellStyles.segmentName,
        scenario === 'SuggestionPill' && searchBoxPillWellStyles.personaSegmentNameAsSuggestionPill
    );

    return (
        <PersonaCardBehavior>
            <div className={searchBoxPillWellStyles.personaPill} key={segment.EmailAddress}>
                <PersonaControl
                    {...{ name, emailAddress }}
                    size={
                        scenario === 'SuggestionMenuItem'
                            ? PersonaSize.extraSmall
                            : PersonaSize.extraExtraSmall
                    }
                    mailboxType={mailBoxType}
                />
                <div className={peopleSuggestionSegmentNameClassNames} title={name}>
                    {/* We don't want to show highlighting when segment is
                        represented as a pill. */}
                    {scenario === 'SuggestionMenuItem' ? (
                        highlightTextRegions
                            .filter(e => e.text.length > 0)
                            .map((e, i) => {
                                const className = e.isHighlighted
                                    ? suggestionStyles.keywordMatchSuggestion
                                    : suggestionStyles.keywordNonMatchSuggestion;
                                return (
                                    <div className={className} key={i}>
                                        {e.text}
                                    </div>
                                );
                            })
                    ) : (
                        <div className={suggestionStyles.keywordNonMatchSuggestion}>
                            {segment.DisplayName}
                        </div>
                    )}
                </div>
            </div>
        </PersonaCardBehavior>
    );
});
